import React, { useMemo } from 'react'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'

import { DRAWER_WIDTH_DIFFERENCE } from 'layouts/Main/components/NavBar/components/MiniDrawer'

import useCustomTheme from 'hooks/useCustomTheme'
import useDaiChat from 'hooks/useDaiChat'
import useDaiChatPanelSize from 'hooks/useDaiChatPanelSize'
import useDrawer from 'hooks/useDrawer'

const DaiChatThemeProvider = ({ children }) => {
  const { customTheme } = useCustomTheme()
  const { chatOpen } = useDaiChat()
  const { panelWidth } = useDaiChatPanelSize()
  const { fixedDrawer } = useDrawer()

  const theme = useMemo(() => {
    if (!chatOpen) return customTheme

    const { values } = customTheme.breakpoints
    const offset = panelWidth + (fixedDrawer ? DRAWER_WIDTH_DIFFERENCE : 0)

    return createTheme({
      ...customTheme,
      breakpoints: {
        values: {
          ...values,
          md: values.md + offset,
          lg: values.lg + offset,
          xl: values.xl + offset,
        },
      },
    })
  }, [chatOpen, fixedDrawer, customTheme, panelWidth])

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default DaiChatThemeProvider
